import { inject, signal } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { BaseComponent } from "./base-component.class";
import { AppHttpService } from "../services/app-http.service";

export abstract class BaseFormComponent extends BaseComponent{

  protected id: number | undefined;
  protected fb = inject(FormBuilder);

  protected isSubmitted = signal<boolean>(false);

  protected checkErrorMessage(form:FormGroup, control: string, isSubmitted:boolean): any {
    return (
      (form.get(control)?.invalid &&
        form.get(control)?.touched) &&
      (form.get(control)?.invalid && isSubmitted)
    );
  }

}
